import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`.endsWith("/")
    ? process.env.REACT_APP_API_URL
    : `${process.env.REACT_APP_API_URL}/`,
});

// Interceptor para adicionar o token atualizado a cada requisição
api.interceptors.request.use(
  (config) => {
    const loggedUser = JSON.parse(localStorage.getItem("asu"));
    if (loggedUser && loggedUser.token) {
      const token = `Bearer ${loggedUser.token}`;
      // Envia ambos os cabeçalhos para máxima compatibilidade
      config.headers["Auth"] = token;
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//api.defaults.withCredentials = true;

export { api };

export const createSession = async (username, password) => {
  return api.post("login.php", { withCredentials: true, username, password });
};

export const getPoints = async () => {
  return api.get("points.php");
};

export const getAlarms = async () => {
  return api.get("alarms.php");
};

export const getDetails = async (id, pointType, dateTime) => {
  return api.get("details.php", { params: { id, pointType, dateTime } });
};

export const update = async (id, columns) => {
  return api.patch("update.php", { id, columns });
};

export const updateConfig = async (id, receiveNotifications, timeInterval) => {
  const origin = navigator.userAgent;
  return api.patch("update-config.php", {
    withCredentials: true,
    id,
    receiveNotifications,
    timeInterval,
    origin,
  });
};

export const storeFCMToken = (userId, token) => {
  const origin = navigator.userAgent;
  return api.post("fcm-subscription.php", {
    withCredentials: true,
    userId,
    token,
    origin,
  });
};
